import { useRenderer } from '@fox/atoms/hooks/use-renderer';
import { tryParseJSONObject } from '@fox/atoms/utils/string';
import { useSubscribeTopicsWithHandler } from '@fox/extensions/src/extension-hooks';
import { ConditionalBlockMeta } from './blocks';
import { IField } from './form-root/contracts';

/**
 * @param dependencies - the dependencies that will trigger a re-render of the form block. Should always include the name of the block in question. Include for example questions that add points for the points block.
 * @param conditionalBlockMeta - the metadata for a conditional block, the block will need to listen to changes in the conditional answers to re-render.
 */
export function useFormBlockReRenderer(dependencies: string[], fieldProps: IField) {
	const render = useRenderer();

	let topics = dependencies.map(d => `form-block-${d}`);

	const conditionalBlockMeta = tryParseJSONObject<ConditionalBlockMeta>(fieldProps?.metadataJson);

	//work out if this block is conditionally rendered, if so, we need to listen to the question answer changes defined in the conditional definitions.
	if (conditionalBlockMeta?.conditionalDefinitions) {
		if (Array.isArray(conditionalBlockMeta.conditionalDefinitions)) {
			const questionNames = conditionalBlockMeta.conditionalDefinitions.map(d => `form-block-${d.questionId}`);
			topics = [...topics, ...questionNames];
		} else {
			const questionName = conditionalBlockMeta.conditionalDefinitions.questionId;
			topics.push(`form-block-${questionName}`);
		}
	}
	useSubscribeTopicsWithHandler(topics, () => {
		render();
	});
}
